import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularExclamationTriangle: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_exclamation-triangle"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="exclamation-triangle icon"
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M16 12.55a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75m0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2M14.039 7.206c.86-1.529 3.062-1.529 3.922 0l8.685 15.44c.844 1.5-.24 3.354-1.96 3.354H7.314c-1.721 0-2.805-1.853-1.961-3.353zm2.615.736a.75.75 0 0 0-1.308 0l-8.685 15.44a.75.75 0 0 0 .654 1.118h17.37a.75.75 0 0 0 .654-1.118z"></path>
      </svg>
    </span>
  );
};

export { RegularExclamationTriangle };
